export class BreedingViewOutputModel {
    constructor(public bmsInformation?: BMSOutputInformation,
                public meansData?: any[],
                public summaryStatsData?: any[],
                public outliersData?: any[]) {
    }
}

export class BMSOutputInformation {
    constructor(public StudyId?: number,
                public WorkbenchProjectId?: number,
                public InputDataSetId?: number,
                public OutputDataSetId?: number) {
    }
}
